// extracted by mini-css-extract-plugin
export default {"content":"other-appointment_content__UUbe-","error-message":"other-appointment_error-message__Ltd9w"};